var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"successAnimationCircle","cx":"35","cy":"35","r":"24","stroke":"#005596","strokeWidth":"2","strokeLinecap":"round","fill":"transparent","key":0}),React.createElement("polyline",{"id":"successAnimationCheck","stroke":"#005596","strokeWidth":"2","points":"23 34 34 43 47 27","fill":"transparent","key":1})]);
}

Success.defaultProps = {"id":"successAnimation","className":"animated","viewBox":"0 0 70 70"};

module.exports = Success;

Success.default = Success;
